import { Component, Input } from '@angular/core';

import { genericComparator } from '../../sorting/sort-utils';

@Component({
  selector: 'app-reference-chips',
  templateUrl: './reference-chips.component.html',
  styleUrls: ['./reference-chips.component.scss'],
  standalone: false,
})
export class ReferenceChipsComponent {
  private chips: string[] = [];

  @Input() public label!: string;
  @Input()
  set referenceChips(value: string[] | null | undefined) {
    this.chips = [...(value ?? [])].sort(genericComparator);
  }

  get referenceChips(): string[] {
    return this.chips;
  }
}
